import React from "react";
import PostCardFooter from "../../../PostCardFooter";
import Button from "../../../../../../components/Button";
import PromotedLabel from "../PromotedLabel";
import "./index.css";

const PostAd = ({ ad: { clickUrl, coverUrl, info, owner }, onClick }) => (
  <div className="post-ad">
    <header className="card-header">
      <a href={clickUrl} target="_blank" onClick={onClick}>
        <img src={owner.picture} alt={owner.name} className="-user-img" />
      </a>
      <div className="-card-data">
        <a href={clickUrl} target="_blank" className="-user-name" onClick={onClick}>
          {owner.name}
        </a>
        <PromotedLabel />
      </div>
    </header>
    <a href={clickUrl} target="_blank" onClick={onClick}>
      <img className="thumbnail" alt="ad" src={coverUrl} />
      <PostCardFooter {...info} maxLength={1000} />
      <div className="actions">
        <Button className="-cancel -no-margin-y" value="Learn More" />
      </div>
    </a>
  </div>
);

export default PostAd;



// WEBPACK FOOTER //
// ./src/components/PostsList/components/AdCard/Components/PostAd/index.js